import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import CM4LogRequest, { CM4LogRequestForm } from '~/features/deviceLogs/components/logRequest/CM4LogRequest';
import moment from 'moment/moment';

interface CM4LogRequestWrapperProps {
    serialNumberList: string[];
    isDeviceLogsUser: boolean;
    requestDisabled: boolean;
}

const CM4LogRequestWrapper: React.FC<CM4LogRequestWrapperProps> = ({
    requestDisabled, isDeviceLogsUser,
    serialNumberList
}) => {
    const methods = useForm<CM4LogRequestForm>({
        defaultValues: {
            dateInput: {
                startValue: moment().startOf('day'),
                endValue: moment(),
            },
            requestedSystem: [],
        },
        mode: 'onChange',
    });

    return <FormProvider {...methods}> <CM4LogRequest serialNumberList={serialNumberList}
                                                      isDeviceLogsUser={isDeviceLogsUser}
                                                      requestDisabled={requestDisabled}/>
    </FormProvider>;
};

export default CM4LogRequestWrapper;
